import React from "react";
import {
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBIcon,
  MDBBtn,
  MDBInput,
} from "mdbreact";
import Button from "@material-ui/core/Button";
import serialize from "form-serialize";
import Contact from "./Contact.css";

var contactForm;

const handleSubmit = (event) => {
  event.preventDefault();
  contactForm = event.target;
  const formData = serialize(event.target, { hash: true });
  const data = `name=${formData.name}&email=${formData.email}&phone=${
    formData.phone
  }&message=${formData.message}`;
  fetch("https://buildgreenalbania.org/blogMng.php?/postEmail", {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: data,
  }).then(
    (result) => {
      alert("Message was received succesfully! Thank you!");
      clearFields();
    },
    (error) => {
      alert("Message cannot be send now! Please contact us in phone number.");
      clearFields();
    }
  );
};

const clearFields = () => {
  contactForm.email.value = "";
  contactForm.name.value = "";
  contactForm.message.value = "";
  contactForm.phone.value = "";
  contactForm.email.defaultValue = "";
  contactForm.name.defaultValue = "";
  contactForm.message.defaultValue = "";
  contactForm.phone.defaultValue = "";
};

const ContactPage = (props) => {
  return (
    <div className="z-depth-5 ">
      <section className="my-5 container">
        <h2 className="mt-2 font-weight-bold text-center my-5 text-success">
          {props.contactTitle}
        </h2>
        {/* <p className="text-center w-responsive mx-auto pb-5">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit,
                  error amet numquam iure provident voluptate esse quasi, veritatis
                  totam voluptas nostrum quisquam eum porro a pariatur veniam.
      </p> */}

        <MDBRow>
          <MDBCol lg="5" className="lg-0 mb-4">
            <MDBCard>
              <MDBCardBody className="z-depth-5">
                <div className="contact-header contact-blue accent-1 modal-header">
                  <h3 className="mt-2">
                    <MDBIcon icon="envelope" /> {props.writeUs}:
                  </h3>
                </div>
                <form id="contactForm" onSubmit={handleSubmit}>
                  <div className="md-form">
                    <MDBInput
                      icon="user"
                      label="Your name"
                      iconClass="grey-text"
                      type="text"
                      id="name"
                      name="name"
                    />
                  </div>
                  <div className="md-form">
                    <MDBInput
                      icon="envelope"
                      label="Your email"
                      iconClass="grey-text"
                      type="text"
                      id="email"
                      name="email"
                    />
                  </div>
                  <div className="md-form">
                    <MDBInput
                      icon="tag"
                      label="Phone"
                      iconClass="grey-text"
                      type="number"
                      id="phone"
                      name="phone"
                    />
                  </div>
                  <div className="md-form">
                    <MDBInput
                      icon="pencil-alt"
                      label="Message"
                      iconClass="grey-text"
                      type="textarea"
                      id="message"
                      name="message"
                    />
                  </div>
                  <div className="text-center">
                    <Button
                      type="submit"
                      rounded
                      className="btn btn-light-blue waves-effect waves-light"
                    >
                      SUBMIT
                    </Button>
                  </div>
                </form>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
          <MDBCol lg="7">
            <div
              id="map-container"
              className="rounded z-depth-1-half map-container z-depth-5"
              style={{ height: "400px" }}
            >
              <iframe
                src="https://maps.google.com/maps?width=100%&height=600&hl=en&coord=41.318868,19.814860&q=Rruga%20%22Nikolla%20Tupe%22%2C%20P%C3%ABrball%C3%AB%20nj%C3%ABsis%C3%AB%20bashkiake%20nr.%205%2C%20Tiran%C3%AB%20Shqip%C3%ABri+(Build%20Green%20Albania%20)&ie=UTF8&t=&z=18&iwloc=B&output=embed"
                title="This is a unique title"
                width="100%"
                height="100%"
                frameBorder="0"
                style={{ border: 0 }}
              />
            </div>
            <br />
            <MDBRow className="text-center">
              <MDBCol md="4">
                <MDBBtn
                  tag="a"
                  hre
                  floating
                  className="btn-floating contact-blue accent-1"
                >
                  <MDBIcon icon="map-marker-alt" />
                </MDBBtn>
                <p>Rruga Nikolla Tupe, Tirana</p>
              </MDBCol>
              <MDBCol md="4">
                <MDBBtn tag="a" floating className="contact-blue accent-1">
                  <MDBIcon icon="envelope" />
                </MDBBtn>
                <p>contact@buildgreenalbania.org</p>
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>
      </section>
    </div>
  );
};

export default ContactPage;



// WEBPACK FOOTER //
// ./src/views/Components/Sections/SectionContacts.jsx